<template>
  <div class="page-module-wrap">
    <!-- 搜索头部分 start -->
    <div class="search">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="section-gap">
            <div class="block">
              <div class="control">
                <label class="label inline-block r-top">活动状态：</label>
                <span class="select">
                      <select style="width:110px;" v-model="search.status">
                        <option value="0">全部</option>
                        <option value="1">未开放</option>
                        <option value="2">开放中</option>
                        <option value="4">已结束</option>
                      </select>
                  </span>
              </div>
              <div class="control">
                <label class="label inline-block r-top">穿衣商家：</label>
                <span class="inline-block">
                  <el-select v-model="search.businessUserId" filterable clearable placeholder="请选择">
                    <el-option
                      v-for="item in allOptions.businessUsers"
                      :key="item.userId"
                      :label="item.username"
                      :value="item.userId">
                    </el-option>
                  </el-select>
                </span>
              </div>
              <div class="control">
                <label class="label inline-block r-top">商品ID：</label>
                <span class="inline-block">
                    <input class="input" type="number" v-model="search.goodsId"/>
                  </span>
              </div>
              <div class="control">
                <label class="label inline-block r-top">限时时间：</label>
                <span class="inline-block">
                  <el-date-picker
                    v-model="search.searchStartTime"
                    type="datetime"
                    placeholder="开始时间"
                    align="right">
                  </el-date-picker>
                </span>
                <span class="r-top">~</span>
                <span class="inline-block">
                    <el-date-picker
                      v-model="search.searchEndTime"
                      type="datetime"
                      placeholder="结束时间"
                      align="right">
                    </el-date-picker>
                </span>
              </div>
            </div>
            <div class="block">
              <button class="button is-info" @click="onSearch">搜索</button>
              <button class="button is-primary" @click="onCreate">创建限时折扣</button>
              <button class="button is-danger" @click="onShowBatchDelete">批量删除限时折扣</button>
            </div>
          </div>
        </article>
      </div>
    </div>
    <!-- 搜索头部分 end -->
    <!-- 列表部分 start -->
    <div class="list-wrap">
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <ul>
            <li class="actv-container" v-for="(actvItem, actvIndex) in list">
              <div class="actv-detail columns" @click="onShowGoods(actvIndex)">
                <span class="column is-1">{{actvItem.timeLimitId}}</span>
                <span class="column is-3 bolder">{{actvItem.startTime}}---{{actvItem.endTime}}</span>
                <span class="column is-2 blue">{{actvItem.name}}</span>
                <span class="column is-2 green">{{actvItem.username}}</span>
                <span class="column is-2">
                <span class="tag"
                      :class="{'is-info':actvItem.status == 1,'is-success':actvItem.status == 2,'is-danger':actvItem.status == 4}">{{actvItem.status | getStatus}}</span>
                </span>
                <span class="column is-1">
                  <a v-if="actvItem.status == 1" @click="onEdit(actvIndex)">编辑</a>
                  <a v-else @click="onEdit(actvIndex)">查看</a>
                </span>
                <span class="column is-1">
                  <a v-if="actvItem.status != 2" class="red" @click.stop="onDelete(actvIndex)">删除</a>
                </span>
              </div>
              <template v-if="actvItem.isShow">
                <table class="table is-bordered">
                  <thead>
                    <tr>
                      <th>商品ID</th>
                      <th>商品名称</th>
                      <th>商品图</th>
                      <th>商品库存</th>
                      <th>SKU数</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="goodItem in actvItem.goodsList">
                      <td>{{goodItem.goodsId}}</td>
                      <td>{{goodItem.name}}</td>
                      <td>
                        <image-component :image="goodItem.image" :width="100" :height="100"></image-component>
                      </td>
                      <td>{{goodItem.stock}}</td>
                      <td>{{goodItem.skuCount}}</td>
                    </tr>
                    <tr v-if="actvItem.goodsCount > 10">
                      <td colspan="5">
                        <a @click="onEdit(actvIndex)">共{{actvItem.goodsCount}}件商品，此处仅显示10件，点击查看全部 &gt;&gt;</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </li>
          </ul>
        </article>
        <!-- 模态弹窗开始 -->
        <el-dialog :title="modal.title" :visible.sync="modal.visible" :lock-scroll='false'>  
          <template v-if="modalType == 'add'">
            <p class="block">
              <span class="modal-tip">1 活动时间和类型一旦确定将无法修改，只能添加、修改商品信息</span>
              <span class="modal-tip">2 开放中的活动不要编辑限时折扣，删除请在活动前确认活动商品信息</span>
            </p>
            <p class="block">
              <label class="label inline-block r-top">活动类型：</label>
              <span class="select">
              <select style="width:110px;" v-model="modal.type">
                <option value="1">单品</option>
              </select>
            </span>
            </p>
            <p class="block">
              <label class="label inline-block r-top">活动名称：</label>
              <input type="text" class="input width-3" v-model="modal.name">
            </p>
            <p class="block">
              <label class="label inline-block r-top">活动时间：</label>
              <span class="inline-block">
                  <el-date-picker
                    v-model="modal.startTime"
                    type="datetime"
                    placeholder="开始时间"
                    align="right">
                  </el-date-picker>
                </span>
                <span class="r-top">~</span>
                <span class="inline-block">
                    <el-date-picker
                      v-model="modal.endTime"
                      type="datetime"
                      placeholder="结束时间"
                      align="right">
                    </el-date-picker>
                </span>
            </p>
          </template>
          <template v-if="modalType == 'batchDelete'" >
            <div style="position: relative;">
              <div class="block">
                <label class="label inline-block r-top">选择折扣时间段：</label>
                <span class="inline-block">
                  <el-date-picker
                    v-model="modal.startTime"
                    type="datetime"
                    placeholder="开始时间"
                    align="right">
                  </el-date-picker>
                </span>
                <span class="r-top">~</span>
                <span class="inline-block">
                    <el-date-picker
                      v-model="modal.endTime"
                      type="datetime"
                      placeholder="结束时间"
                      align="right">
                    </el-date-picker>
                </span>
              </div>
              <div class="block">
                <label class="label inline-block r-top">输入商品ID：</label>
                <textarea cols="30" rows="10" v-model="modal.goodsIds" class="textarea" placeholder="多个ID请使用换行区分"></textarea>
              </div>
              <div class="mask" v-if="modal.loading">
                <div class="loading">
                  <p>删除中...</p>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="modalType == 'confirmDelete'">
            <label class="label">如下商品活动时间段与选择时间段不服，是否确认删除？</label>
            <table class="table is-bordered">
              <thead>
                <tr>
                  <th>商品ID</th>
                  <th>开始时间</th>
                  <th>结束时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in modal.fails">
                  <td>{{item.goodsId}}</td>
                  <td>{{item.startTime}}</td>
                  <td>{{item.endTime}}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <span slot="footer" class="dialog-footer">
            <el-button @click="modal.visible = false">取 消</el-button>
            <el-button type="primary" @click="MODAL_OK_EVENT()">{{ modal.okText }}</el-button>            
          </span>
        </el-dialog>  
        <!-- 模态弹窗结束 -->
      </div>
      <div v-if="count > 0" class="clearfix">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="search.page"
          :page-size="20"
          layout="total, prev, pager, next, jumper"
          :total="count"
          class="fright">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import { formatDate, getTimeByTimeString, getTimeByDateStr } from 'UTILS/date'
  export default {
    components:{
    },
    mounted(){
      this.getAllOpts()
      // debugger
      this.$message('数据获取中...')
      setTimeout(() => {
        this.getList()
      }, 2000);
    },
    data(){
      return {
        search:{
          page:1,
          status: '0', //活动状态
          searchStartTime: '', //选中的限时折扣开始时间
          searchEndTime: '', //选中的限时折扣结束时间
//          priceMin: '', //选中的限时折扣的价格 下限
//          priceMax: '', //选中的限时折扣的价格 max
//          discountMin: '', //选中的折扣范围 min
//          discountMax: '', //选中的折扣范围  max
          businessUserId:'',
          goodsId:'',
          type:1  //1:goods  2:suit
        },
        count:0,
        list:[],
        allOptions:{
          businessUsers:[]
        },
        modal:{
          visible:false,
          title:'',
          type:'1',
          name:'',
          startTime:'',
          endTime:'',
          goodsIds:'',
          okText:'',
          loading:false,
          fails:[]
        },
        modalType:'',
        startTime:'',
        endTime:''
      }
    },
    watch:{
      'modal.visible'(){//监听modal.visible变化重置modal中组件
        if(this.modal.visible == false){
          setTimeout(()=>{
            this.modal = {
              visible:false,
              type:'1',
              name:'',
              startTime:'',
              endTime:'',
              goodsIds:'',
              title:'',
              okText:''
            }
          },200);
        }
      }
    },
    methods:{
      MODAL_OK_EVENT(){
        if(this.modalType == "add"){
          this.onCreateCount();
        }else if(this.modalType == "batchDelete"){
          this.doBatchDelete();
        }else if(this.modalType == "confirmDelete"){
          this.doBatchDelete(true);
        }
      },
      getList(){
        HttpRequest.post('/admin.php?method=timelimit.getList',this.search).then(response => {
          this.count = response.data.count
          this.list = _.toArray(response.data.list)
          _.each(this.list,(item,index)=>{
            item.goodsList = []
            item.goodsCount = ''
            item.isShow = false
            item.startTime = formatDate(item.startTime,'yyyy-MM-dd hh:mm:ss');
            item.endTime = formatDate(item.endTime,'yyyy-MM-dd hh:mm:ss');
            if(item.status == 2){
              this.onShowGoods(index)
            }      
          })
        }) 
      },
      /**
       * 切换页面
       */
      handleCurrentChange(page){
        if(this.search.page !== page){
          this.search.page = page;
          this.getList();
        }
      },

      /**
       * 展示活动包含的商品
       */
      onShowGoods(index){
        let list = JSON.parse(JSON.stringify(this.list))
        list[index].isShow = !list[index].isShow
        this.$set(this.list, index, list[index])
        let params = {
          timeLimitId: this.list[index].timeLimitId,
          pageSize: 10,
          isReturnSku: 0
        }
        if (!this.list[index].goodsList.length) {
          HttpRequest.post('/admin.php?method=timelimit.getTimelimitDetail', params).then(response => {
            list[index].goodsList = _.toArray(response.data.goodsList)
            list[index].goodsCount = response.data.count
            this.$set(this.list, index, list[index])
          })
        }
      },
      /**
       * 删除限时折扣
       */
      onDelete(index){
        if(!confirm('确认删除？')){
          return false
        }
        let parmas = {
          timeLimitId:this.list[index].timeLimitId
        }
        HttpRequest.post('/admin.php?method=timelimit.remove',parmas).then(response => {
          if(response.data.result){
            this.$message('删除成功！')
            this.getList()
          }
        })
      },
      /**
       * 创建限时折扣
       */
      onCreate(){
        this.modalType = "add";
        this.modal.title = "创建限时折扣";
        this.modal.okText = "下一步";
        this.modal.visible = true;
      },
      /**
       * 搜索
       */
      onSearch(){
        this.search.page = 1
        this.getList()
      },
      onCreateCount(){
        this.modal.visible = false
        if(this.modal.okText == "下一步"){
          this.startTime = getTimeByDateStr(this.modal.startTime)
          this.endTime = getTimeByDateStr(this.modal.endTime)
          this.createTimeLimit();
        }
      },
      /**
       * 跳转编辑页
       * @param index
       */
      onEdit(index){
        let item = this.list[index],handleType = 3
        if(item.status == 1){
          handleType = 2
        }
        let params = {
          handleType:handleType, //1:创建  2:编辑  3:查看
          type:item.type,
          name:item.name,
          startTime:item.startTime,
          endTime:item.endTime,
          timeLimitId:item.timeLimitId
        }
        this.$router.push('/innerGoods/editTimeLimit?params='+JSON.stringify(params))
      },
      getAllOpts(){
        //穿衣商家
        HttpRequest.post('/admin.php?method=business.getUserList').then(response => {
          this.allOptions.businessUsers = _.toArray(response.data.list)
          this.allOptions.businessUsers.unshift({
            userId: -1,
            username: '全部'
          })
        })
      },
      /**
       * 创建限时折扣
       */
      createTimeLimit(){
        if(!this.modal.name){
          this.$message('活动名不能为空！')
          return false
        }else if(!this.modal.startTime || !this.modal.endTime){
          this.$message('活动时间不能为空！')
          return false
        }else if(getTimeByTimeString(this.modal.startTime) < Math.round(new Date().getTime()/1000)
          || getTimeByTimeString(this.modal.endTime) < Math.round(new Date().getTime()/1000)){
          this.$message('活动时间不能小于当前时间！')
          return false
        }
        this.modal.visible = false
        let params = {
          handleType:1, //1:创建  2:编辑  3:查看
          type:this.modal.type,
          name:this.modal.name,
          startTime:this.startTime,
          endTime:this.endTime
        }
        this.$router.push('/innerGoods/editTimeLimit?params='+JSON.stringify(params))
      },
      onSelectBusinessUser(obj){
        if(obj){
          this.search.businessUserId = obj.userId
        }else{
          this.search.businessUserId = ""
        }
      },
      /**
       * 展示批量删除限时折扣Modal
       */
      onShowBatchDelete(){
        this.modalType = "batchDelete";
        this.modal.title = "批量删除限时折扣";
        this.modal.okText = "确定";
        this.modal.visible = true;
      },
      /**
       * 进行批量删除
       */
      doBatchDelete(isForce = 0){
        if(this.modal.loading){
          this.$message("正在删除中，请稍后...",2000)
          return false
        }
        let params = {};
        if(!this.modal.goodsIds.trim().length){
          this.$message("请输入商品ID！")
          return false
        }
        if(!this.modal.startTime || !this.modal.endTime){
          this.$message("结束时间和开始时间不能为空！");
          return false;
        }
        params = {
          startTime:this.modal.startTime,
          endTime:this.modal.endTime,
          goodsIds:this.modal.goodsIds
        }
        if(isForce){
          params.force = 1;
        }
        this.modal.loading = true;
        HttpRequest.post('/admin.php?method=timelimit.batchRemove',params).then(response => {
          if(response.data.success && !_.size(response.data.fails)){
            this.$message("批量删除成功!2秒后更新列表");
            this.modal.loading = false;
            this.modal.visible = false;
            setTimeout(()=>{
              this.getList();
            },2000)
          }else if(_.size(response.data.fails)){
            this.modal.loading = false;
            this.modalType = "confirmDelete";
            this.modal.title = "提示";
            this.modal.fails = _.toArray(response.data.fails)
          }
        })
      }
    },
    filters:{
      getStatus(status){
        status = status && status.toString()
        switch (status){
          case '1':
            return '未开始';
            break;
          case '2':
            return '开放中';
            break;
          case '4':
            return '已结束';
            break;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .page-module-wrap {
    td {
      text-align: center;
      span {
        word-break: break-all;
      }
      input {
        text-align: center;
      }
    }
    th {
      text-align: center;
    }
    p {
      word-break: break-all;
    }

    .red {
      color: red;
    }
    .green {
      color: green;
    }
    .blue {
      color:blue;
    }
    .bolder {
      font-weight: bold;
    }
    .margin-top {
      margin-top: 10px;
    }
    .margin-left {
      margin-left: 40px;
    }
    .width-1 {
      width: 100px;
    }
    .width-2 {
      width: 180px;
    }
    .width-3 {
      width:260px;
    }
    .inline-block {
      display: inline-block;
    }
    .vertical-middle {
      vertical-align: middle;
    }

    .title {
      font-size: 16px;
      height: 25px;
      line-height: 16px;
      padding-left: 6px;
      padding-right: 6px;
      font-weight: bold;
    }

    .control {
      display: inline-block;
      margin-right: 20px;
    }
    .margin-left1 {
      margin-left: 20px;
    }
    .r-top {
      position: relative;
      top: 5px;
    }
    .danger {
      background-color: #ed6c63;
      border-color: transparent;
      color: white;
    }
    .list-wrap {
      padding-bottom: 40px;
      .actv-container {
        width:100%;
        padding:0 10px 16px;
        border-radius:5px;
        box-shadow:2px 2px 3px 1px #ccc;
        margin-top: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        border: 1px solid #ccc;
        &:not(:last-child){
          margin-bottom: 40px;
        }
        .actv-detail {
          width:100%;
          padding:0 10px;
          margin-top: 10px;
        }
      }
      .modal-tip {
        color:#666;
        display: block;
      }
    }
    .data-isnull {
      display: inline-block;
      width: 100%;
      font-size: 25px;
      color: #ccc;
      text-align: center;
    }
    .mask {
      position: absolute;
      top:0;
      left:50%;
      margin-left: -75px;
      .loading{
        width: 150px;
        height: 15px;
        margin: 0 auto;
        margin-top:100px;
      }
      .loading span{
        display: inline-block;
        width: 15px;
        height: 100%;
        margin-right: 5px;
        background: rgba(0,0,0,.7);
        -webkit-transform-origin: right bottom;
        -webkit-animation: load 1s ease infinite;
      }
      p {
        text-align: center;
        color:red;
        margin-bottom: 10px;
      }
      .loading span:last-child{
        margin-right: 0px;
      }
      @-webkit-keyframes load{
        0%{
          opacity: 1;
        }
        100%{
          opacity: 0;
          -webkit-transform: rotate(90deg);
        }
      }
      .loading span:nth-child(1){
        -webkit-animation-delay:0.13s;
      }
      .loading span:nth-child(2){
        -webkit-animation-delay:0.26s;
      }
      .loading span:nth-child(3){
        -webkit-animation-delay:0.39s;
      }
      .loading span:nth-child(4){
        -webkit-animation-delay:0.52s;
      }
      .loading span:nth-child(5){
        -webkit-animation-delay:0.65s;
      }
    }
  }
</style>
